import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Badge,
  Box,
  Drawer,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { appIcons } from "../../assets";
import GlobalButton from "../button";
import CustomDrawer from "./Drawer";
import Navlinks from "./Navlinks";
import ProfileMenu from "./ProfileMenu";
import { useSelector } from "react-redux";
import { t } from "i18next";

const drawerWidth = 280;

export default function Header(props) {
  const { window } = props;
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const userData = useSelector((state) => state.userReducer.user);
  const cartData = useSelector((state) => state.cartReducer.cartData);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="static"
        sx={{
          boxShadow: "none",
          background: "transparent",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">EaziDay</Typography>

          <Stack direction={"row"} alignItems={"center"} gap={{ xs: 1, md: 2 }}>
            <Navlinks />

            <IconButton
              sx={{ display: { md: "none" }, p: "0px" }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon sx={{ color: "text.white" }} />
            </IconButton>

            {userData ? (
              <Stack direction={"row"} alignItems={"center"} gap={1}>
                <ProfileMenu />
              </Stack>
            ) : (
              <GlobalButton
                btnText={"getStartNow"}
                handleClickBtn={() => navigate("/login")}
                styleProps={{
                  backgroundColor: "text.coralRed",
                  display: { xs: "none", md: "flex" },
                }}
              />
            )}
            <IconButton onClick={() => navigate("/cart")}>
              <Badge
                badgeContent={cartData?.length === 0 ? "0" : cartData?.length}
                sx={{
                  "& .MuiBadge-badge": {
                    backgroundColor: "text.coralRed",
                    color: "text.white",
                  },
                }}
              >
                <img src={appIcons.shoppingCartIcon} alt="cart" />
              </Badge>
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer for small screens */}
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          <CustomDrawer handleDrawerToggle={() => setMobileOpen(false)} />
        </Drawer>
      </nav>
    </Box>
  );
}
